import { Component, OnInit, ViewChild, ElementRef, VERSION } from '@angular/core';
import { fromEvent } from 'rxjs';
import { Router } from '@angular/router';
@Component({
    selector: 'app-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.scss'],
    standalone: false
})
export class SiteFooterComponent implements OnInit {
  @ViewChild('disclaimer', { static: true }) disclaimer: ElementRef;
  year: number = new Date().getFullYear();
  constructor(private router: Router) { }

  ngOnInit() {
    console.log("Angular Version: ", VERSION.full);
    fromEvent(document, 'click').subscribe((event: any) => {
      event.stopPropagation();
      if (this.disclaimer) {
        const ref = (this.disclaimer.nativeElement as HTMLElement);
        if (!ref.contains(event.target) && ref.classList.contains('disclaimer-open')) {
          ref.classList.remove('disclaimer-open');
        }
      }
    });
  }

  toggleDisclaimer(): void {
    const ref = (this.disclaimer.nativeElement as HTMLElement);
    ref.classList.toggle('disclaimer-open');
  }

  setOnAppClick() {
    localStorage.removeItem("topMenu");
    localStorage.setItem("topMenu", "applications");
    this.router.navigate(['/applications/favorites']);
  }

  setOnReportClick() {
    localStorage.removeItem("topMenu");
    localStorage.setItem("topMenu", "reports");
    this.router.navigate(['/requests/new']);
  }

}
